export default __webpack_public_path__ + "static/media/claro-0.d218b9bd.JPG";